import './paymentModal.css';
import React, {Component} from "react";
import CurrencyInput from "react-currency-input-field";

interface PaymentModalProps {
    friendName: string,
    totalDebt: number,
    onConfirm: (amount: number) => void,
    onCancel: () => void,
}

interface PaymentModalState {
    amount: string,
    error?: string,
}

class PaymentModal extends Component<PaymentModalProps, PaymentModalState> {
    constructor(props: PaymentModalProps) {
        super(props);
        this.state = {
            amount: "",
        };
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
    }

    handleAmountChange(value: string | undefined) {
        if (!value) {
            this.setState({amount: "", error: undefined});
            return;
        }
        const numValue = parseFloat(value.replace(/[^0-9.-]/g, ''));
        if (isNaN(numValue) || numValue <= 0) {
            this.setState({amount: value, error: "Amount must be greater than 0"});
        } else if (numValue > this.props.totalDebt / 100) {
            this.setState({amount: value, error: `Amount cannot exceed €${(this.props.totalDebt / 100).toFixed(2)}`});
        } else {
            this.setState({amount: value, error: undefined});
        }
    }

    handleConfirm() {
        if (!this.state.amount || this.state.error) {
            return;
        }
        const amount = parseFloat(this.state.amount.replace(/[^0-9.-]/g, ''));
        if (isNaN(amount) || amount <= 0) {
            this.setState({error: "Please enter a valid amount"});
            return;
        }
        this.props.onConfirm(Math.round(amount * 100)); // Convert to cents
    }

    render() {
        return (
            <div className="PaymentModal-Backdrop" onClick={this.props.onCancel}>
                <div className="PaymentModal-Container" onClick={(e) => e.stopPropagation()}>
                    <h2 className="PaymentModal-Title">Record Payment</h2>
                    <p className="PaymentModal-Description">
                        You owe <strong>{this.props.friendName}</strong> €{(this.props.totalDebt / 100).toFixed(2)}
                    </p>
                    <div className="PaymentModal-InputGroup">
                        <label className="PaymentModal-Label">Payment Amount (€)</label>
                        <CurrencyInput
                            className="PaymentModal-Input"
                            prefix="€"
                            decimalsLimit={2}
                            value={this.state.amount}
                            onValueChange={this.handleAmountChange}
                            placeholder="0.00"
                            allowNegativeValue={false}
                            autoFocus
                        />
                        {this.state.error && (
                            <div className="PaymentModal-Error">{this.state.error}</div>
                        )}
                    </div>
                    <div className="PaymentModal-Actions">
                        <button className="PaymentModal-Button PaymentModal-ButtonCancel" onClick={this.props.onCancel}>
                            Cancel
                        </button>
                        <button 
                            className="PaymentModal-Button PaymentModal-ButtonConfirm" 
                            onClick={this.handleConfirm}
                            disabled={!this.state.amount || !!this.state.error}
                        >
                            Confirm Payment
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default PaymentModal;

